export interface TypeAheadUserGroups{
    Links: {
        Self:string;
    }
    UserGroups:UserGroupLight[];
}

export interface PhoenixUserGroup {
	IsSystemGroup: boolean;
	UserCount: number;
	UserGroupId: number;
	UserGroupName: string;
}

export interface UserGroupLight {
    UserGroupId:number;
    UserGroupName:string;
}

export function isUserGroup(obj):obj is PhoenixUserGroup {
    return angular.isDefined(obj.UserGroupId) && angular.isDefined(obj.UserGroupName);
}


// WEBPACK FOOTER //
// ./src/phoenix/domain/phoenix-user-group.ts